import React from "react"
import { IconProps } from "./interfaces/IconProps.interface"

const Percent = ({ color = "#000", ...rest }: IconProps) => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
            <g clipPath="url(#clip0_165_4234)">
                <path
                    d="M11.6667 14C11.0478 14 10.4543 13.7542 10.0168 13.3166C9.57917 12.879 9.33333 12.2855 9.33333 11.6667C9.33333 11.0478 9.57917 10.4543 10.0168 10.0168C10.4543 9.57917 11.0478 9.33333 11.6667 9.33333C12.2855 9.33333 12.879 9.57917 13.3166 10.0168C13.7542 10.4543 14 11.0478 14 11.6667C14 12.2855 13.7542 12.879 13.3166 13.3166C12.879 13.7542 12.2855 14 11.6667 14ZM4.33333 6.66667C4.02692 6.66667 3.7235 6.60631 3.44041 6.48905C3.15731 6.37179 2.90009 6.19992 2.68342 5.98325C2.46675 5.76658 2.29488 5.50935 2.17761 5.22626C2.06035 4.94317 2 4.63975 2 4.33333C2 4.02692 2.06035 3.7235 2.17761 3.44041C2.29488 3.15731 2.46675 2.90009 2.68342 2.68342C2.90009 2.46675 3.15731 2.29488 3.44041 2.17761C3.7235 2.06035 4.02692 2 4.33333 2C4.95217 2 5.54566 2.24583 5.98325 2.68342C6.42083 3.121 6.66667 3.71449 6.66667 4.33333C6.66667 4.95217 6.42083 5.54566 5.98325 5.98325C5.54566 6.42083 4.95217 6.66667 4.33333 6.66667ZM12.714 2.34333L13.6567 3.286L3.28667 13.6567L2.344 12.714L12.7133 2.34333H12.714Z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="clip0_165_4234">
                    <rect width="16" height="16" fill={color} />
                </clipPath>
            </defs>
        </svg>
    )
}

export default Percent
